import { defineStore } from "pinia";

export const useCounterStore = defineStore("counter", {
  state: () => ({
    rail: true,
    drawer: false,
    isDark: localStorage.getItem("isDark"),
    userData: JSON.parse(localStorage.getItem("userData")),
    placesList:[],
    addTravelData: {
      title: "",
      price: 0,
      creatorUserId: null,
      dateFrom: null,
      dateTo: null,
      description: "",
      imageUrl: "",
      memberNumber: 0,
      places: [],
    },
  }),
  getters: {
    isRail(state) {
      if (state.rail === true) return true;
      return false;
    },
  },
  actions: {
    railChange() {
      this.rail = !this.rail;
    },
    drawerChange() {
      this.drawer = !this.drawer;
    },
  },
});
